import React from 'react'
import { SVGUniqueID } from 'react-svg-unique-id'

export default function W2({ width, height }) {
  return (
    <SVGUniqueID>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={width}
        height={height}
        fill='none'
        viewBox='0 0 70 70'
      >
        <g clipPath='url(#clip0_9)'>
          <path
            fill='url(#paint0_linear_9)'
            d='M10 69.5A9.56 9.56 0 01.5 60V10A9.56 9.56 0 0110 .5h50a9.56 9.56 0 019.5 9.5v50a9.56 9.56 0 01-9.5 9.5H10z'
          />
          <path
            fill='#fff'
            d='M60 1a9 9 0 019 9v50a9 9 0 01-9 9H10a9 9 0 01-9-9V10a9 9 0 019-9h50zm0-1H10A10 10 0 000 10v50a10 10 0 0010 10h50a10 10 0 0010-10V10A10 10 0 0060 0z'
          />
          <path
            fill='url(#paint1_linear_9)'
            d='M22.77 32.54c5.396 0 9.77-4.374 9.77-9.77S28.166 13 22.77 13 13 17.374 13 22.77s4.374 9.77 9.77 9.77z'
          />
          <path
            fill='url(#paint2_linear_9)'
            stroke='#0B0A09'
            d='M22.77 29.83a7.06 7.06 0 100-14.12 7.06 7.06 0 000 14.12z'
          />
          <g>
            <path
              fill='url(#paint3_linear_9)'
              d='M46.77 56.54c5.396 0 9.77-4.374 9.77-9.77S52.166 37 46.77 37 37 41.374 37 46.77s4.374 9.77 9.77 9.77z'
            />
            <path
              fill='url(#paint4_linear_9)'
              stroke='#0B0A09'
              d='M46.77 53.83a7.06 7.06 0 100-14.12 7.06 7.06 0 000 14.12z'
            />
          </g>
        </g>
        <defs>
          <linearGradient
            id='paint0_linear_9'
            x1='35'
            x2='35'
            y1='69.5'
            y2='.5'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#BCC5C7' />
            <stop offset='.65' stopColor='#E6E8E9' />
          </linearGradient>
          <linearGradient
            id='paint1_linear_9'
            x1='22.776'
            x2='22.772'
            y1='32.544'
            y2='13.004'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#fff' />
            <stop offset='1' stopColor='#A4B0B2' />
          </linearGradient>
          <linearGradient
            id='paint2_linear_9'
            x1='22.77'
            x2='22.77'
            y1='16.21'
            y2='29.33'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#F7F3CE' />
            <stop offset='1' stopColor='#E0DCBC' />
          </linearGradient>
          <linearGradient
            id='paint3_linear_9'
            x1='46.776'
            x2='46.772'
            y1='56.544'
            y2='37.004'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#fff' />
            <stop offset='1' stopColor='#A4B0B2' />
          </linearGradient>
          <linearGradient
            id='paint4_linear_9'
            x1='46.77'
            x2='46.77'
            y1='40.21'
            y2='53.33'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#F7F3CE' />
            <stop offset='1' stopColor='#E0DCBC' />
          </linearGradient>
          <clipPath id='clip0_9'>
            <path fill='#fff' d='M0 0h70v70H0z' />
          </clipPath>
        </defs>
      </svg>
    </SVGUniqueID>
  )
}
